import { Users, Edit, Trash2, User, Lock, Unlock } from "lucide-react";
import MatiereBadge from "./MatiereBadge";

const CardGroup = ({ groupe, onEdit,cancelEditing,handleDetailGroupeClick, editedNomGroupe, setEditedNomGroupe, editingGroup,profDetail, editedProfesseur, setEditedProfesseur,
     handleUpdateGroupe, onDelete, onViewStudents  }) => {
  const getGroupeInitials = (nom) => {
    if (!nom) return '';
    
    if (nom.includes(' ')) {
      return nom.split(' ')
        .slice(0, 3)
        .map(word => word.charAt(0))
        .join('')
        .toUpperCase();
    }
    
    return nom.substring(0, 3).toUpperCase();
  };
const isEditing = editingGroup && editingGroup.id === groupe.id;

  return (
    <div 
      className="bg-gradient-to-br from-white to-blue-50 relative group border-2 border-blue-200 rounded-2xl p-6 xl:p-4 2xl:p-5 3xl:p-6
      transition-all duration-300 cursor-pointer hover:border-blue-400 hover:-translate-y-1 hover:shadow-lg"
      onClick={() => onViewStudents(groupe)}
    >
     {/* Boutons d'actions - visibles au survol - DESCENDUS */}
<div className="absolute top-12 xl:top-10 2xl:top-11 3xl:top-12 right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex gap-1">
    {isEditing ? (
          <>
            <div className="flex gap-2 items-center">
              <button
                className="w-7 h-7 bg-green-500 hover:bg-green-600 text-white rounded-lg flex items-center justify-center text-xs transition-all hover:scale-110 shadow-md"
                onClick={(e) => {
                  e.stopPropagation();
                  handleUpdateGroupe(groupe.id);
                }}
                title="Valider"
              >
                ✓
              </button>
              <button
                className="w-7 h-7 bg-gray-500 hover:bg-gray-600 text-white rounded-lg flex items-center justify-center text-xs transition-all hover:scale-110 shadow-md"
                onClick={(e) => {
                  e.stopPropagation();
                  cancelEditing();
                }}
                title="Annuler"
              >
                ✕
              </button>
            </div>
            </>
          ) :
          <>
  <button
    className="w-8 h-8 bg-blue-500 hover:bg-blue-600 text-white rounded-lg flex items-center justify-center text-xs transition-all hover:scale-110 shadow-md"
    onClick={(e) => {
      e.stopPropagation();
    handleDetailGroupeClick(groupe);
    }}
    title="Voir les élèves"
  >
    <Users size={16} />
  </button>
  <button 
    className="w-8 h-8 bg-yellow-500 hover:bg-yellow-600 text-white rounded-lg flex items-center justify-center text-xs transition-all hover:scale-110 shadow-md"
   onClick={(event) => onEdit(event, groupe)}
    title="Modifier"
  >
    <Edit size={16} />
  </button>
  <button
    className="w-8 h-8 bg-orange-500 hover:bg-orange-600 text-white rounded-lg flex items-center justify-center text-xs transition-all hover:scale-110 shadow-md"
    onClick={(e) => {
      e.stopPropagation();
      onDelete(groupe.id);
    }}
    title="Supprimer"
  >
    <Trash2 size={16} />
  </button>
  </>}
</div>

      {/* Badge niveau */}
      <div className="absolute top-0 left-0 bg-blue-600 text-white text-xs xl:text-[10px] 2xl:text-[11px] 3xl:text-xs font-bold px-3 xl:px-2 2xl:px-2.5 3xl:px-3 py-1 rounded-br-lg rounded-tl-2xl">
        {groupe.niveau}
      </div>

      {/* Badge statut */}
      <div className={`absolute top-0 right-0 px-3 xl:px-2 2xl:px-2.5 3xl:px-3 py-1 rounded-bl-lg rounded-tr-2xl text-xs xl:text-[10px] 2xl:text-[11px] 3xl:text-xs font-bold flex items-center gap-1 ${
        groupe.statut ? 'bg-green-500 text-white' : 'bg-red-500 text-white'
      }`}>
        {groupe.statut ? <Unlock size={12} /> : <Lock size={12} />}
        {groupe.statut ? "Déverrouillé" : "Verrouillé"}
      </div>

      {/* Header avec avatar et nom */}
      <div className="flex items-center gap-4 xl:gap-3 2xl:gap-3.5 3xl:gap-4 mb-6 xl:mb-4 2xl:mb-5 3xl:mb-6 mt-8 xl:mt-6 2xl:mt-7 3xl:mt-8">
          <div 
            className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-400 to-sky-300  
            flex items-center justify-center text-white xl:text-xl font-bold border-4 border-white border-opacity-30">
          {getGroupeInitials(groupe.nom)}
        </div>
        <div className="flex-1">
           {isEditing ? (
              <div className="space-y-2">
                <input
                  type="text"
                  value={editedNomGroupe}
                  onChange={(e) => setEditedNomGroupe(e.target.value)}
                  className="w-3/4 text-base font-semibold text-gray-800 bg-yellow-50 border-2
                   border-yellow-300 rounded-lg px-2 py-1 focus:outline-none focus:border-yellow-500"
                  placeholder="Nom"
                  autoFocus
                  onClick={(e) => e.stopPropagation()}
                />
              </div>
            ):
        <div>
           <h3 className="text-xl xl:text-sm 2xl:text-base 3xl:text-xl font-semibold text-gray-800 mb-1">
            {groupe.nom}
          </h3>
        </div>
}
          {groupe.matiere && (
            <div className="mb-1.5">
              <MatiereBadge matiere={groupe.matiere} />
            </div>
          )}
          <div className="text-sm xl:text-xs 2xl:text-xs 3xl:text-sm text-gray-600">
            {groupe.classes_detail?.map((classe, index) => (
              <span key={classe} className="inline-block bg-orange-200 px-2 xl:px-1.5 2xl:px-1.5 3xl:px-2 py-1 xl:py-0.5 2xl:py-0.5 3xl:py-1 rounded-md mr-1 mb-1 xl:text-[10px] 2xl:text-[11px] 3xl:text-xs">
                {classe}
              </span>
            ))}
          </div>
        </div>
      </div>
      
      {/* Stats section */}
      <div className="grid grid-cols-2 gap-4 xl:gap-2 2xl:gap-3 3xl:gap-4 mb-6 xl:mb-4 2xl:mb-5 3xl:mb-6">
        <div className="text-center bg-indigo-50 rounded-xl p-3 xl:p-2 2xl:p-2.5 3xl:p-3">
          <div className="text-2xl xl:text-lg 2xl:text-xl 3xl:text-2xl font-bold text-indigo-600">{groupe.eleves?.length || 0}</div>
          <div className="text-xs xl:text-[10px] 2xl:text-[11px] 3xl:text-xs text-indigo-500 font-medium">Élèves</div>
        </div>
        <div className="text-center bg-blue-50 rounded-xl p-3 xl:p-2 2xl:p-2.5 3xl:p-3">
          <div className="text-2xl xl:text-lg 2xl:text-xl 3xl:text-2xl font-bold text-blue-600">{groupe.niveau}</div>
          <div className="text-xs xl:text-[10px] 2xl:text-[11px] 3xl:text-xs text-blue-500 font-medium">Niveau</div>
        </div>
      </div>
      
      {/* Professeur section */}
      <div className="bg-sky-100 rounded-xl p-2 xl:p-1.5 2xl:p-2 3xl:p-2">
        <div className="flex items-center gap-2 text-gray-700">
          <User size={16} className="text-gray-500 xl:w-3.5 xl:h-3.5 2xl:w-4 2xl:h-4 3xl:w-4 3xl:h-4" />
            {isEditing ? (
  <select
              value={editedProfesseur || ""}
              onChange={(e) => setEditedProfesseur(e.target.value)}
              className="w-full text-base bg-yellow-50 border-2 border-yellow-300 rounded-lg px-3 py-2 focus:outline-none focus:border-yellow-500 cursor-pointer"
              onClick={(e) => e.stopPropagation()}
            >
              <option value="" disabled>Sélectionner un professeur</option>
              {profDetail && profDetail.map((prof) => (
                <option key={prof.id} value={prof.id}>
                  {prof.prenom} {prof.nom}
                </option>
              ))}
            </select>
  ) : 
          <span className="text-sm xl:text-xs 2xl:text-xs 3xl:text-sm font-medium">{groupe.professeur_nom}</span>
}
        </div>
        <div className="text-xs xl:text-[10px] 2xl:text-[11px] 3xl:text-xs text-gray-500 mt-1">Professeur en charge</div>
      </div>
    </div>
  );
};

export default CardGroup;